import * as React from "react";
import { cn } from "@/lib/utils";

export interface SectionHeaderProps {
  eyebrow?: string;
  title: string | React.ReactNode;
  subtitle?: string;
  center?: boolean;
  gradientTitle?: boolean;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  eyebrow,
  title,
  subtitle,
  center = true,
  gradientTitle = false,
  className,
}) => {
  return (
    <div className={cn("mb-20", center && "text-center", className)}>
      {eyebrow && (
        <div className="inline-block px-4 py-2 bg-lime/20 border border-lime rounded-full text-lime text-xs font-bold uppercase tracking-wider mb-6">
          {eyebrow}
        </div>
      )}
      <h2 className={cn("text-5xl md:text-6xl font-black text-white leading-tight", gradientTitle && "text-gradient-lime")}>{title}</h2>
      {subtitle && (
        <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mt-4">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeader;


